
import { Component, Prop } from 'vue-property-decorator';
import Listing from 'ah-common-lib/src/common/components/listing/Listing.vue';
import { PaginatedQuery, Individual, IndividualType, RegistrationStatus } from 'ah-api-gateways';
import { companyMemberTableFieldsFull } from '@/app/components/individual/tableFields/companyMemberTableFields';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';

@Component({
  components: {
    StatusPill,
  },
})
export default class IndividualListing extends Listing<Individual> {
  @Prop({ default: () => ({ tableFields: companyMemberTableFieldsFull }) }) config!: { tableFields: [] };

  protected loadDataRequest(query: PaginatedQuery) {
    return this.$services.individual.listIndividuals({
      ...query,
    });
  }

  private isAdmin(item: Individual) {
    return [IndividualType.PARTNER_ADMIN, IndividualType.CLIENT_ADMIN].includes(item.type);
  }

  private rowColorClass(individual: Individual) {
    if (individual && !this.isAdmin(individual) && individual.status !== RegistrationStatus.APPROVED) {
      return 'warning';
    }
  }

  private individualAttrs(individual: Individual) {
    const label = individual.status === RegistrationStatus.INVITED ? 'Invited' : 'Proposed';
    return {
      label,
      color: 'warning',
    };
  }

  private isApproved(individual: Individual) {
    return individual.status === RegistrationStatus.APPROVED;
  }
}
